import { render } from "./ycmx.vue?vue&type=template&id=c57ff080&scoped=true&ts=true"
import script from "./ycmx.vue?vue&type=script&lang=ts"
export * from "./ycmx.vue?vue&type=script&lang=ts"

import "./ycmx.vue?vue&type=style&index=0&id=c57ff080&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c57ff080"]])

export default __exports__